import { Component, OnInit, inject, signal } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { IdTagStatusEnum } from 'src/app/shared/enums/id-tag-status.enum';
import { IdTagService } from 'src/app/shared/services/id-tag.service';
import { IdTag } from '../id-tag-model';
import { FeedbackFailComponent, FeedbackInfoComponent, FeedbackSuccessComponent, SnackbarService } from 'ok-angular-shared/components';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'adm-id-tag-toggle-blocked-modal-component',
  templateUrl: './id-tag-toggle-blocked-modal.component.html',
  styleUrls: ['./id-tag-toggle-blocked-modal.component.scss'],
  imports: [
    FeedbackSuccessComponent,
    FeedbackFailComponent,
    FeedbackInfoComponent,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatButton,
    MatIcon,
  ],
})
export class IdTagToggleBlockedModalComponent implements OnInit {
  dialogRef = inject<MatDialogRef<IdTagToggleBlockedModalComponent>>(MatDialogRef);
  data = inject<{
    idTagId: number;
  }>(MAT_DIALOG_DATA);
  private idTagService = inject(IdTagService);
  private snackbarService = inject(SnackbarService);

  public idTag = signal<IdTag | null>(null);
  public idTagStatusEnum: typeof IdTagStatusEnum = IdTagStatusEnum;
  public statusChangeDone = false;
  public saving = false;
  public idTagActiveOnInit: boolean;

  async ngOnInit(): Promise<void> {
    if (!this.data?.idTagId) {
      this.snackbarService.error('Brikken kunne ikke findes.');
      this.dialogRef.close();
      return;
    }

    try {
      const idTag = await firstValueFrom(this.idTagService.getIdTag(this.data.idTagId));
      this.idTag.set(idTag);
      this.idTagActiveOnInit = idTag.status.toString() === IdTagStatusEnum[IdTagStatusEnum.Active] ? true : false;
    } catch {
      // Without this, the dialog would otherwise stay open showing only an empty backdrop.
      this.snackbarService.error('Brikken kunne ikke hentes. Prøv venligst igen.');
      this.dialogRef.close();
    }
  }

  public async toggleIdTag(idTag: IdTag) {
    this.saving = true;

    if (idTag.status.toString() === IdTagStatusEnum[IdTagStatusEnum.Active]) {
      idTag.status = IdTagStatusEnum.NoIdTagGroup;
    } else if (idTag.status.toString() === IdTagStatusEnum[IdTagStatusEnum.NoIdTagGroup]) {
      idTag.status = IdTagStatusEnum.Active;
    }

    this.idTagService
      .setStatus(idTag)
      .subscribe({
        next: async result => {
          const idTagId = result;
          idTag = await firstValueFrom(this.idTagService.getIdTag(idTagId));
          this.statusChangeDone = true;
          this.saving = false;
          this.dialogRef.close(idTag);
        },
      })
      .add(() => {
        if (this.saving) {
          this.dialogRef.close();
        }
      });
  }

  public cancel() {
    this.dialogRef.close(this.idTag());
  }
}
